import {EGiftCardProducts} from './EGiftCardOptions/EGiftCardProducts';
import {Header} from './Header/Header';
import './EditRetailer.sass';

const EditRetailer = () => (
  <div className="edit-retailer-container">
    <Header />
    <EGiftCardProducts />
  </div>
);

export default EditRetailer;
